import React from 'react'

import { Button } from '../Styled/Shared'
import { LoginContainer } from './Common'
import CloseButton from '../Shared/CloseButton'
import { LoginView } from '../../reducers'

type Props = {
  hide: () => void
  showView: (view: LoginView) => void
}

const LoginViewSelect: React.SFC<Props> = (props: Props) => (
  <LoginContainer>
    <div className="modal-inner">
      <h4>
        Log in
        <div className="spacer" />
        <CloseButton
          white={true}
          style={{ float: 'right' }}
          onClick={props.hide}
        />
      </h4>
      <div className="content">
        <h2>Already have an account?</h2>
        <p>We need you to login for you to be able to SAVE your design.</p>
        <Button
          onClick={() => props.showView('login')}
          full={true}
          primary={true}
        >
          Login
        </Button>
        <h3>Don't have an account? </h3>
        <h3>
          {' '}
          Please create account{' '}
          <a
            href="https://myaccount.peikkodesigner.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>{' '}
        </h3>
      </div>
    </div>
  </LoginContainer>
)

export default LoginViewSelect



// WEBPACK FOOTER //
// ./src/Components/LoginForm/Select.tsx